import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";

export const setCountAction = () => {
    const countAction = new CountAction(document.querySelector('[data-pickup-search]'));
    countAction.on('countChange', (e) => {
        const target = document.querySelector('[data-pickup-count]');
        countUpAction(target, e.count);
        if (e.count == 0) {
            document.querySelector('.p-submit-result__target').dataset.empty = '';
            document.querySelectorAll('.c-others-search-submit .c-buttons-submit').forEach(button => button.setAttribute('disabled', ''));
        } else {
            delete document.querySelector('.p-submit-result__target').dataset.empty;
            document.querySelectorAll('.c-others-search-submit .c-buttons-submit').forEach(button => button.removeAttribute('disabled'));
        }
    });
}
